(function ($, Drupal) {

  "use strict";

  Drupal.behaviors.articleBody = {
    attach: function (context, settings) {
      const articleMaxHeight = 800;
      const $article = $('.article__body', context);
      const $readMore = $article.find('.article__body__read-more');
      $article.imagesLoaded(function () {
        const height = $article.outerHeight();

        if (height > articleMaxHeight) {
          $article
            .addClass('truncated')
            .height(articleMaxHeight);

          $readMore.on('click', function (event) {
            event.preventDefault();
            $article.height(height)
              .removeClass('truncated');
          })
        }
      });
    }
  };

})(jQuery, Drupal);
